<div class="row">
  <div class="col-12">
    <h3>Start Building Your Custom Report!</h3>
  </div>
  <div class="col-12 col-md-4 col-lg-3">
    <select
      [ngModel]="chosenReport"
      (ngModelChange)="reportTypeChanged($event)"
      class="form-control">
      <option disabled [value]="null">Select a Report...</option>
      <option *ngFor="let report of availableReports" [value]="report.Id">
        {{ report.Value }}
      </option>
    </select>
  </div>
  @if (!hideJumbo) {
    <div class="col-12">
      <img src="assets/images/reports_jumbo.png" class="mb-3 jumbo-img" />
    </div>
  }
</div>
<div class="row">
  <div class="col-12">
    @switch (chosenReport) {
      @case (-2) {
        <p>Audit log of changes made to employees/contractors.</p>
      }
      @case (1) {
        <p>
          Record of total earnings, taxes, and deduction compensation per employee based on a
          selected date range. Report will also detail employer totals for the selected date range
          at the bottom of the report.
        </p>
      }
      @case (2) {
        <p>Summary of an employee's period end date, check date, and period totals.</p>
      }
      @case (3) {
        <p>Includes time off accrued hours, used hours, and remaining balance by employees.</p>
      }
      @case (4) {
        <p>
          Summary of earnings/wages paid by job codes or department with MTD, QTD, YTD, and job cost
          totals.
        </p>
      }
      @case (5) {
        <p>Active employee list of hourly rates and effective dates.</p>
      }
      @case (6) {
        <p>List of calculated taxes due for each tax agency.</p>
      }
      @case (7) {
        <p>Workers' Comp earnings by timeframe.</p>
      }
      @case (8) {
        <p>
          Recap of all earnings, deductions, net pay, federal/local/state taxes, and number of
          employees paid/hired/terminated.
        </p>
      }
      @case (9) {
        <p>Comprehensive report of employee information and status.</p>
      }
      @case (10) {
        <p>Current employee plan participation of retirement accounts (401k, IRA, etc).</p>
      }
      @case (11) {
        <p>Employee Medical or Dental plan deduction history and YTD earnings.</p>
      }
      @case (12) {
        <p>Detailed data records of client and employee demographic information and totals.</p>
      }
      @case (13) {
        <p>Data entry sheet intended for the next scheduled payroll.</p>
      }
      @case (14) {}
      @case (15) {
        <p>Total tax obligations debited from a client's account.</p>
      }
      @case (16) {}
      @case (17) {
        <p>Detailed report data per employee, department, or job code.</p>
      }
      @case (19) {
        <p>
          Includes time off accrued hours, used hours, and remaining balance by employees for a
          selected timeframe.
        </p>
      }
    }
  </div>
</div>
@if (chosenReport > 0) {
  <div class="row" *ngIf="chosenReport > 0">
    <div class="col-12">
      <p class="fw-bold cp-green">
        Note: All date parameters reference pay dates and not payroll period start/end dates
      </p>
    </div>
  </div>
}
@if (chosenReport != null && chosenReport != 0) {
  <hr />
}
<div>
  @switch (chosenReport) {
    @case (-1) {
      <lib-on-demand-reports
        [clientCode]="clientCode"
        reportView="payroll-audit"></lib-on-demand-reports>
    }
    @case (-2) {
      <lib-on-demand-reports
        [clientCode]="clientCode"
        reportView="people-changes"></lib-on-demand-reports>
    }
    @case (1) {
      <lib-employee-payroll-totals
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-employee-payroll-totals>
    }
    @case (2) {
      <lib-employee-payroll-history
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-employee-payroll-history>
    }
    @case (3) {
      <lib-employee-time-off-report
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-employee-time-off-report>
    }
    @case (4) {
      <lib-labor-allocation-summary
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-labor-allocation-summary>
    }
    @case (5) {
      <lib-employee-rates
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-employee-rates>
    }
    @case (6) {
      <lib-tax-activity-by-agency
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-tax-activity-by-agency>
    }
    @case (7) {
      <lib-workers-compensation
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-workers-compensation>
    }
    @case (8) {
      <lib-client-totals-recap
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-client-totals-recap>
    }
    @case (9) {
      <lib-employee-info-and-status
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-employee-info-and-status>
    }
    @case (10) {
      <lib-investment-plan
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-investment-plan>
    }
    @case (11) {
      <lib-medical-census
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-medical-census>
    }
    @case (12) {
      <lib-new-client-setup
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-new-client-setup>
    }
    @case (13) {
      <lib-worksheet
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-worksheet>
    }
    @case (14) {
      <lib-fica-excess-tip
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-fica-excess-tip>
    }
    @case (15) {
      <lib-tax-liability-by-agency
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-tax-liability-by-agency>
    }
    @case (16) {
      <lib-employee-fica
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-employee-fica>
    }
    @case (17) {
      <lib-labor-detail-with-totals
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-labor-detail-with-totals>
    }
    @case (19) {
      <lib-time-off-report
        [clientCode]="clientCode"
        (reportGenerated)="displayHtmlReport($event)"
        (reportDownloadClicked)="downloadReport($event)"></lib-time-off-report>
    }
  }
</div>
@if (chosenReport != null && chosenReport > 0) {
  <hr />
}
<div class="w-75 mb-5" id="htmlOutput"></div>
